//Principais
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
//Services
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { AtribuicaoLoginSed, UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { PsicologoService } from 'src/app/shared/services/psicologo.service';
//Models
import { Router } from '@angular/router';
import { Polo } from 'src/app/shared/models/polo/Polo';
import { PoloDiretoriaEscola } from 'src/app/shared/models/polo/PoloDiretoriaEscola';
import { Psicologo } from 'src/app/shared/models/psicologo/Psicologo';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
    selector: 'app-psicologo-add',
    templateUrl: './psicologo-add.component.html',
    styleUrls: ['./psicologo-add.component.scss'],
    standalone: true,
    imports:[convivaCommonImports,angularCommonImports,libsCommonImports]
})
export class AdicionarPsicologoComponent implements OnInit {
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  constructor(

    private authService: AuthService,
    private psicologoService: PsicologoService,
    private toastr: ToastrService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private ConvivaErrors: ConvivaErrorHandlingService,
  )
  {
    this.userLogado = this.authService.getUser();
    if(this.userLogado != null){
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  public submitted = false;

  public polos: Polo[] = [];
  public nomePsicologo:string;
  public codigoCPF:number;
  public codigoRG:number;
  public codigoCRP:number;
  public telefone:number;
  public email:string;

  public uf = [
    { id: 'AC', name: 'AC' },
    { id: 'AL', name: 'AL' },
    { id: 'AM', name: 'AM' },
    { id: 'AP', name: 'AP' },
    { id: 'BA', name: 'BA' },
    { id: 'CE', name: 'CE' },
    { id: 'DF', name: 'DF' },
    { id: 'ES', name: 'ES' },
    { id: 'GO', name: 'GO' },
    { id: 'MA', name: 'MA' },
    { id: 'MG', name: 'MG' },
    { id: 'MS', name: 'MS' },
    { id: 'MT', name: 'MT' },
    { id: 'PA', name: 'PA' },
    { id: 'PB', name: 'PB' },
    { id: 'PE', name: 'PE' },
    { id: 'PI', name: 'PI' },
    { id: 'PR', name: 'PR' },
    { id: 'RJ', name: 'RJ' },
    { id: 'RN', name: 'RN' },
    { id: 'RO', name: 'RO' },
    { id: 'RR', name: 'RR' },
    { id: 'RS', name: 'RS' },
    { id: 'SC', name: 'SC' },
    { id: 'SE', name: 'SE' },
    { id: 'SP', name: 'SP' },
    { id: 'TO', name: 'TO' }
  ];
  public diretoriaEscolas: PoloDiretoriaEscola;
  public formCadastrar!: FormGroup;

  public get form() {
    return this.formCadastrar.controls;
  }

  public ngOnInit() {
    this.formCadastrar = new FormGroup({
      codigoPolo: new FormControl(null, [Validators.required]),
      codigoUF: new FormControl(null, [Validators.required]),
      nomePsicologo: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required]),
      telefone: new FormControl(null, [Validators.required]),
      codigoCRP: new FormControl(null, [Validators.required]),
      codigoRG: new FormControl(null, [Validators.required]),
      codigoCPF: new FormControl(null, [Validators.required])
    });
    this.spinnerService.show();
    this.getPolos();
    this.spinnerService.hide();
  }

  public async getPolos() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos())
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    this.spinnerService.hide();
  }

  public OnLimpar() {
    this.polos = [];
    this.spinnerService.show();
    this.getPolos();
    this.formCadastrar.get('codigoPolo')?.patchValue(null);
    this.formCadastrar.get('nomePsicologo')?.patchValue(null);
    this.formCadastrar.get('codigoCPF')?.patchValue(null);
    this.formCadastrar.get('codigoRG')?.patchValue(null);
    this.formCadastrar.get('codigoUF')?.patchValue(null);
    this.formCadastrar.get('codigoCRP')?.patchValue(null);
    this.formCadastrar.get('telefone')?.patchValue(null);
    this.formCadastrar.get('email')?.patchValue(null);
    this.spinnerService.hide();
  }

  public async OnSalvar() {
    this.submitted = true;
    this.spinnerService.show();
    const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const codigoCPF = this.formCadastrar.get('codigoCPF')?.value;
    const codigoRG = this.formCadastrar.get('codigoRG')?.value;
    const codigoUF = this.formCadastrar.get('codigoUF')?.value;
    const codigoCRP = this.formCadastrar.get('codigoCRP')?.value;
    const telefone = this.formCadastrar.get('telefone')?.value;
    const nomePsicologo = this.formCadastrar.get('nomePsicologo')?.value
    const email = this.formCadastrar.get('email')?.value;

    if(codigoCPF == undefined || codigoCPF == "" || codigoCPF.length != 11 || !this.validarCPF(codigoCPF))
    {
      this.toastr.warning('CPF invalido.');
      this.formCadastrar.get('codigoCPF')?.addValidators([Validators.required]);
      this.formCadastrar.get('codigoCPF')?.updateValueAndValidity();
      this.spinnerService.hide();
      return;
    }
    if(codigoRG == undefined || codigoRG == "" || codigoRG.length != 9)
    {
      this.toastr.warning('RG invalido.');
      this.formCadastrar.get('codigoRG')?.addValidators([Validators.required]);
      this.formCadastrar.get('codigoRG')?.updateValueAndValidity();
    }
    if(codigoUF == undefined || codigoUF == "")
    {
      this.toastr.warning('UF invalido.');
      this.formCadastrar.get('codigoUF')?.addValidators([Validators.required]);
      this.formCadastrar.get('codigoUF')?.updateValueAndValidity();
    }
    if(codigoCRP == undefined || codigoCRP == "" || codigoCRP.length != 7)
    {
      this.toastr.warning('CRP invalido.');
      this.formCadastrar.get('codigoCRP')?.addValidators([Validators.required]);
      this.formCadastrar.get('codigoCRP')?.updateValueAndValidity();
    }
    if(telefone == undefined || telefone == "")
    {
      this.toastr.warning('Telefone invalido.');
      this.formCadastrar.get('telefone')?.addValidators([Validators.required]);
      this.formCadastrar.get('telefone')?.updateValueAndValidity();
    }
    if(nomePsicologo == undefined || nomePsicologo == "")
    {
      this.toastr.warning('Nome invalido.');
      this.formCadastrar.get('nomePsicologo')?.addValidators([Validators.required]);
      this.formCadastrar.get('nomePsicologo')?.updateValueAndValidity();
    }
    if(!regexEmail.test(email)) {
      this.toastr.warning('Email invalido.');
      this.formCadastrar.get('email')?.addValidators([Validators.email]);
      this.formCadastrar.get('email')?.updateValueAndValidity();
    }
    if (this.formCadastrar.invalid) {
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(codigoCPF))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    if(response.data != null)
      this.toastr.warning('Este CPF já foi inserido.');
    else{
      const objetoPsicologo: Psicologo = {
        codigoPolo: this.formCadastrar.get('codigoPolo')?.value,
        nomePsicologo: nomePsicologo,
        codigoCPF: codigoCPF,
        codigoRG: codigoRG,
        codigoUF: codigoUF,
        codigoCRP: codigoCRP,
        telefone: telefone,
        email: email,
      };
      const responseCadastro = await lastValueFrom(this.psicologoService.setCadastrarPsicologo(objetoPsicologo))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      if(!responseCadastro.isSucess){
        this.toastr.error(responseCadastro.message);
        this.spinnerService.hide();
        return;
      }
      this.spinnerService.hide();
      this.toastr.success('Psicologo cadastrado com sucesso.');
      this.OnLimpar();
    }
    this.spinnerService.hide();
  }

  OnVoltar() {
    this.router.navigate(['/manutencao-psicologo']);
  }

  validarCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]/g, '');

    if (cpf.length !== 11) {
      return false;
    }

    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }

    let sum = 0;
    let remainder;

    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }

    remainder = (sum * 10) % 11;

    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }

    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return false;
    }

    sum = 0;

    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }

    remainder = (sum * 10) % 11;

    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }

    return remainder === parseInt(cpf.substring(10, 11));
  }
}
